import { useSearchParams } from 'react-router-dom';

/**
 * Returns true when ?edit=true is in the URL.
 * Admin check can be added later (e.g. && useIsAdmin()).
 */
export function useEditMode(): boolean {
  const [searchParams] = useSearchParams();
  return searchParams.get('edit') === 'true';
}
